export default __webpack_public_path__ + "static/media/milestone 4600.49ada14a.svg";